import { render, staticRenderFns } from "./TabNote.vue?vue&type=template&id=29923d89&scoped=true&"
import script from "./TabNote.vue?vue&type=script&lang=js&"
export * from "./TabNote.vue?vue&type=script&lang=js&"
import style0 from "./TabNote.vue?vue&type=style&index=0&id=29923d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29923d89",
  null
  
)

export default component.exports